import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";
import Cookies from "universal-cookie";
import InfoMorbilidad from "./InfoMorbilidad";
import IndicadorMorbilidadManual from "../../Manual/IndicadorMoribilidadManual";
import Swal from "sweetalert2";
import { obtenerInstituciones } from "../../Services/Rest";

function MorbilidadInstitucional() {
  const cookies = new Cookies();
  const tipoUsuario = parseInt(cookies.get("tipo_Usuario"));
  const [isLoading, setLoading] = useState(false);
  const [archivos, setArchivos] = useState(null);
  const [postGrupo, setPostGrupo] = useState("");
  const [instituciones, setInstituciones] = useState([]);
  const [institucionSeleccionada, setInstitucionSeleccionada] = useState("");

  useEffect(() => {
    if (tipoUsuario === 1) {
      InstitucionObetner();
    }
  }, []);

  const InstitucionObetner = async () => {
    try {
      const response = await axios.get(obtenerInstituciones);
      setInstituciones(response.data);
    } catch (error) {
      console.error("Error al obtener las instituciones:", error);
    }
  };

  const subirArchivos = (e) => {
    setArchivos(e);
  };

  const insertarArchivos = async () => {
    if (!postGrupo) {
      Swal.fire("Debe seleccionar un grupo", "", "warning");
      return;
    }

    if (tipoUsuario === 1 && !institucionSeleccionada) {
      Swal.fire("Debe seleccionar una institución", "", "warning");
      return;
    }

    const f = new FormData();
    for (let index = 0; index < archivos.length; index++) {
      f.append("files", archivos[index]);
    }

    const institucionId =
      tipoUsuario === 1
        ? institucionSeleccionada
        : cookies.get("institucionid");

    const username = "BasicAuth@icontec.org";
    const password = "yQLzqmR7eZSuAmQZUqhY";
    const basicAuth = btoa(`${username}:${password}`);

    try {
      const response = await axios.post(
        `https://suadesarrollo.azurewebsites.net/api/CargaMasivosIndicadorMorbilidad?Grupo=${postGrupo}&InstitucionId=${institucionId}`,
        f,
        {
          headers: {
            Authorization: `Basic ${basicAuth}`,
          },
        },
      );

      Swal.fire({
        title: response.data,
        icon: "success",
      }).then(function () {
        window.location.reload("/");
      });
    } catch (error) {
      Swal.fire({
        title: "Error al subir archivo",
        text: error.message,
        icon: "error",
      });
    }
  };

  return (
    <Fragment>
      <div className="container">
        <div className="text-center">
          <div className="container-fluid">
            <div className="card shadow mb-4">
              <div className="card-header py-3">
                <h6 className="m-0 font-weight-bold text-primary">
                  Indicadores Grupo C1
                </h6>
              </div>
              <div className="card-body">
                {(tipoUsuario === 1 || tipoUsuario === 2) && (
                  <a
                    href="../../Indicadores/FormatoIndicadorMorbilidad.csv"
                    download
                  >
                    Descargar Formato
                  </a>
                )}

                {(tipoUsuario == 1 || tipoUsuario === 2) && (
                  <div className="table-responsive mt-3">
                    <table
                      className="table table-bordered"
                      id="dataTable"
                      width="100%"
                      cellSpacing="0"
                    >
                      <thead>
                        <tr>
                          <td>Escoja el grupo a insertar</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            {tipoUsuario === 1 && (
                              <div className="mb-3">
                                <label className="font-weight-bold">
                                  Seleccione institución:
                                </label>
                                <select
                                  className="form-control"
                                  value={institucionSeleccionada}
                                  onChange={(e) =>
                                    setInstitucionSeleccionada(e.target.value)
                                  }
                                >
                                  <option value="">
                                    Seleccione institución
                                  </option>
                                  {instituciones.map((inst) => (
                                    <option key={inst.id} value={inst.id}>
                                      {inst.razon_Social}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            )}

                            <hr />
                            <select
                              className="form-control"
                              onChange={(e) => setPostGrupo(e.target.value)}
                              value={postGrupo}
                            >
                              <option value="">Seleccione</option>
                              <option value="c 1">
                                C1. Primeras causas de morbilidad institucional
                                hospitalaria
                              </option>
                              <option value="c1.1">
                                C1.1 Primeras causas de morbilidad hosp General
                                Adultos
                              </option>
                              <option value="c1.2">
                                C1.2 Primeras causa morbilidad hosp. General
                                Pediatria
                              </option>
                              <option value="c1.3">
                                C1.3 Primeras causas morbilidad hosp.
                                Ginecoobstetricia
                              </option>
                              <option value="c1.4">
                                C1.4 Primeras causas morbilidad hosp. Cirugía
                              </option>
                              <option value="c1.5">
                                C1.5 Primeras causas morbilidad cuidados
                                intensivos
                              </option>
                              <option value="c1.6">
                                C1.6 Primeras causas morbilidad servicio
                                urgencias
                              </option>
                              <option value="c1.7">
                                C1.7 Primeras causas morbilidad consulta externa
                              </option>
                              <option value="c1.8">
                                C1.8 Primeras causas morbilidad cirugía
                                ambulatoria
                              </option>
                              <option value="c1.9">
                                C1.9 Primeras causas morbilidad odontología
                              </option>
                            </select>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <input
                              type="file"
                              name="files"
                              accept=".csv"
                              multiple
                              onChange={(e) => subirArchivos(e.target.files)}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {!isLoading ? (
                              <button
                                className="btn btn-primary btn-block"
                                onClick={insertarArchivos}
                              >
                                Guardar
                              </button>
                            ) : (
                              <button
                                className="btn btn-secondary btn-block"
                                disabled
                              >
                                Cargando...
                              </button>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )}

                <InfoMorbilidad />
              </div>
            </div>
          </div>
        </div>
        <IndicadorMorbilidadManual />
      </div>
    </Fragment>
  );
}

export default MorbilidadInstitucional;
